import Phaser from "phaser";
import  VfxSprite  from "./VfxSprite.js"

class MouseChaser extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y) {
        super(scene, x, y, '');
        this.scene = scene;
        scene.add.existing(this);

        // declare sounds first
        this.snd_house_power = this.scene.sound.add('snd_house_power');
        this.LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

        // fetching values from local storage or use default values
        this.soundVolumeFromStorage = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);
        this.soundVolume = this.soundVolumeFromStorage !== null ? +this.soundVolumeFromStorage / 100 : 12.5 / 100;

        this.checkForVolumeChange = () => {
            let newSoundVolume = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);
            newSoundVolume = newSoundVolume !== null ? +newSoundVolume / 100 : 12.5 / 100;

            if (this.soundVolume !== newSoundVolume) {
                this.soundVolume = newSoundVolume;

                this.snd_house_power.setVolume(this.soundVolume);
            }
        }

        this.scene.time.addEvent({
            delay: 500,
            callback: this.checkForVolumeChange,
            loop: true
        });

        this.moveFunction = (pointer) => {
            new VfxSprite(this.scene, pointer.x, pointer.y, 'vfx-green-ball4', 0, {
                direction: 1,
                scale: 1,
                frames: 20,
            });
        }

        this.downFunction = (pointer) => {
            new VfxSprite(this.scene, pointer.x, pointer.y, 'vfx-pink-ball', 0, {
                direction: 1,
                scale: 4.5,
                frames: 20,
            });
            this.snd_house_power.play();
            this.snd_house_power.setVolume(this.soundVolume);

        }
    }

    enableChaser() {
        this.scene.input.on('pointermove', this.moveFunction, this);
        this.scene.input.on('pointerdown', this.downFunction, this);
    }

    disableChaser() {
        this.scene.input.off('pointermove', this.moveFunction);
        this.scene.input.off('pointerdown', this.downFunction);
    }
}

export default MouseChaser;